exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.quiz-init-container .content {\n  padding: 10px 20px 0;\n}\n@media screen and (min-height: 570px) {\n.quiz-init-container .content {\n    padding: 60px 37px 0;\n}\n}\n@media screen and (min-height: 669px) {\n.quiz-init-container .content {\n    padding: 95px 37px 0;\n}\n}", ""]);

// exports
